/* BI-05 · CANCELLATION
   One contextual offer, never a maze: cancellation stays visible at every
   step, and issued gifts stay consultable and redeemable. */
import { Button, Card, KV } from '@/ui'
import { Head, useBill } from './ParamShell'

export default function BI05Annuler() {
  const c = useBill().cancel
  return (
    <section data-frame="BI-05" style={{ display: 'grid', gap: 14 }}>
      <Head title="Annuler l’abonnement" />
      <Card>
        <KV rows={[['Raison (facultatif)', c.reasons]]} />
      </Card>
      <Card>
        <strong>Avant de partir :</strong> passer à l’offre gratuite (1 établissement) · mettre en pause (si
        éligible) · aide à la configuration · <strong>une</strong> offre contextuelle : −50 %
        pendant 3 mois. L’annulation reste visible à chaque étape.
      </Card>
      <Card>
        <KV rows={[
          ['Fin d’accès', c.endDate],
          ['Vos données', c.dataRetention],
        ]} />
      </Card>
      <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap' }}>
        <Button variant="quiet" size="sm">Garder mon offre</Button>
        <Button variant="danger" size="sm">Confirmer l’annulation</Button>
      </div>
    </section>
  )
}
